import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountingRoutingModule } from './accounting-routing.module';
import { AccountComponent } from './account/account.component';
import { MaterialModule } from '../../material/material.module';
import { InvoiceComponent } from './invoice/invoice.component';
import { AccountingComponent } from './accounting.component';
import { AccountDetailsComponent } from './account/account-details/account-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { LogsComponent } from './logs/logs.component';
import { StripeComponent } from './stripe/stripe.component';
import { TransactionsTableComponent } from './stripe/transactions-table/transactions-table.component';
import { PaginationTableComponent } from './stripe/paginationtable/pagination-table.component';
import { TransactionsService } from './stripe/transactions.service';
import { StripeLogsComponent } from './stripe-logs/stripe-logs.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [
    AccountComponent,
    InvoiceComponent,
    StripeComponent,
    AccountingComponent,
    AccountDetailsComponent,
    LogsComponent,
    TransactionsTableComponent,
    PaginationTableComponent,
    StripeLogsComponent,
  ],
  imports: [
    CommonModule,
    AccountingRoutingModule,
    MaterialModule,
      MatTableModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    FormsModule,
    HighchartsChartModule,
  ],
  exports: [LogsComponent],
  providers: [TransactionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AccountingModule {}
